module.exports = __webpack_public_path__ + "static/img/laolang.0566fc75.png";